export default "__VITE_PUBLIC_ASSET__19fde408__"